import React from "react";

export const Testimonials = (props) => {
  return (
    <div id="testimonials">
      <div className="container">
        <div className="section-title text-center">
          <p>NOSSOS DEPOIMENTOS</p>
          <h2>Avaliações de Pacientes</h2>     
        </div>     

        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.name}-${i}`} className="col-md-4">
                  <div className="testimonial">
                    <div className="testimonial-image">
                      {" "}
                      <img src={d.img} alt="" />{" "}
                    </div>
                    <div className="testimonial-content">
                      <p>"{d.text}"</p>
                      <div className="testimonial-meta"> - {d.name} </div>
                    </div>
                  </div>
                </div>
              ))
            : "loading"}
        </div>

        <div className="section-title text-center">        
          <a href="https://api.whatsapp.com/send?phone=5521980366885&text=Ol%C3%A1,%20vi%20a%20p%C3%A1gina%20web%20e%20%20gostaria%20de%20agendar%20uma%20consulta%20com%20a%20Dra.%20Gabriela%20Antonio." className="btn btn-custom btn-lg page-scroll" target="_blank"rel="noreferrer">
            Agendar Consulta <i className="fa fa-whatsapp"></i>
          </a>{" "}
        </div>
        
        
        
        
        
      </div>
    </div>
  );
};
